export const PRODUCTION_TYPE = "production";
export const DELIVERY_TYPE = "delivery";
export const DELIVERY_GROUP_CODE = "driver";